import React, { useContext } from 'react';
import { PapiDeviation } from '@wix/da-types-papi';
import { withTranslation, WithTranslation } from 'react-i18next';
import OverlayContext from '@wix/da-shared-react/pkg/DeviationViews/Thumb/Standard/Overlay/OverlayContext';
import StandardThumb from '@wix/da-shared-react/pkg/DeviationViews/Thumb/Standard';
import Button from '@wix/da-shared-react/pkg/Button';
import ThumbInfo from '@wix/da-shared-react/pkg/ThumbInfo';
import ErrorBoundary from '@wix/da-shared-react/pkg/ErrorBoundary';
import { Url } from '@wix/da-url';
import { useFlag } from '@wix/da-shared-react/pkg/redux/flags/hooks/useFlag';
import { MobileContext } from '@wix/da-shared-react/pkg/Context';

import s from './FeaturedDeviationThumb.scss';

export interface Props {
  deviation: PapiDeviation;
  width?: number;
  height?: number;
  isMobile?: boolean;
  showMatureContent?: boolean;
}

export const FeaturedDeviationThumb: React.SFC<Props & WithTranslation> = ({
  deviation: { title, author, deviationId, printId },
  deviation,
  width,
  height,
  t,
}) => {
  const isNewThumbEnabled = useFlag('spotlight_updated');
  const isMobile = useContext(MobileContext);

  return (
    <div className={s['root']}>
      <ErrorBoundary>
        <OverlayContext.Provider
          value={{
            showAuthor: false,
            showTitle: false,
            showLoveControl: false,
          }}
        >
          <StandardThumb deviation={deviation} width={width} height={height} />
        </OverlayContext.Provider>
        <ThumbInfo
          height={82}
          urlDeviation={deviation}
          user={author!}
          title={title}
          extra={
            !!printId &&
            (isNewThumbEnabled && isMobile ? (
              <Button
                view="b18"
                height="small"
                href={Url.printLink(deviationId!)}
              >
                {t('common.buy')}
              </Button>
            ) : (
              <Button
                className={s['btn-buy']}
                view="b18"
                height="small"
                href={Url.printLink(deviationId!)}
              >
                {t('common.buy')}
              </Button>
            ))
          }
        />
      </ErrorBoundary>
    </div>
  );
};
FeaturedDeviationThumb.displayName = 'FeaturedDeviationThumb';

export default withTranslation()(FeaturedDeviationThumb);
